import template from './index.html.twig';
import './index.scss';

Shopware.Component.register('bf-ebay-connection-assistant-index', {
    template
});

